import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\node_modules\\react-toastify\\dist\\index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\_auth\\providers\\AuthProvider.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\app\\globals.css");
;
import(/* webpackMode: "eager" */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\node_modules\\react-toastify\\dist\\ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\providers\\DatabaseProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\providers\\FormErrorProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\providers\\FormSpinnerProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\providers\\FormThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Auto-IT\\Apps\\PortalAdmin\\portal-admin3\\src\\providers\\ReduxProvider.tsx");
